// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"26n5k":[function(require,module,exports) {
require("32f4f186b1340ddd").register(require("20f30af087700421").getBundleURL("3hrBO"), JSON.parse('["3hrBO","index.4bf6fd5f.js","7toSX","LoginView.04dd19c9.js","7ypJH","FourOhFour.3391c2b3.js","d59zn","NoAccess.15ee921e.js","9LmwR","ProfileView.90612625.js","4ArSj","ProfileView.0f582730.js","faPhe","UpdatePasswordView.18e17523.js","4TXql","ConfirmAccountView.ebf3c8c3.js","gZvrp","ForgotView.c5ba1636.js","arEOJ","RegisterView.2a75d536.js","1GtTv","LogoutView.73eef1a2.js","5wZjF","AdminView.5f4ab28a.js","7MLCI","AdminView.ca866dbd.js","015Rs","Datasets.1b6acb7c.js","3YNlu","Datasets.1b58d739.js","cyX69","Datasets.ba88b202.js","1EMmz","DatasetDetails.76e93cb5.js","aWsl6","DatasetDetails.5e00c514.js","cAMQi","NewDataset.8b4bd027.js","l4xBs","ExamplesList.114adba6.js","iIiw4","QuestionnairesView.3deab085.js","1Rk1O","QuestionnaireDetails.1fa60483.js","6erLm","QuestionnaireDetails.af1a7666.js","gvUqt","QuestionnaireDetails.a015bce8.js","2HWCT","QuestionnaireDetails.e357b1af.js","kWPXJ","LabelingInterface.6c9f338e.js","dc5JR","LabelingInterface.10b3bd39.js","3AmuR","LabelingInterface.ba64498f.js","dv5TK","LabelingInterface.e73ff908.js","jvJEO","LabelingInterface.1cdb6acb.js","7FZdG","LabelingInterface.e3f72308.js","emyFz","SingleExampleLabeling.b747682e.js","cNumd","SummarizationStudio.72fbd0c0.js","4UDB2","SummarizationStudio.744ce380.js","eDtjD","ExtractionStudio.caf45a25.js","3YW4J","ExtractionStudio.5ac5c177.js","iSsDA","ExtractionStudio.4a884126.js","fynPD","ClassificationStudio.cd5b4485.js","eWEOq","DatasetsAndModels.a9cb013a.js","9R9NG","ModelDetails.f5533581.js","72L0Q","SunbowList.2d09824c.js","jrw8h","ReviewQueue.4fce4638.js","jTMf2","ReviewQueue.38623c6b.js","1J263","interval.7e2ac949.js","4NaWb","timeout.b6bf9ce0.js","8OA2V","ReviewQueue.518e51f0.css","cjBhy","ExceptionsQueue.d4373607.js","2Z3Z9","SingleReviewQueue.ea8e8bd0.js","kJ0sc","SingleExceptionsQueue.7b3d8d85.js","5anOP","SingleQueueSuccess.eccc8820.js","7JbLF","WorkflowsList.16243425.js","a6sen","WorkflowDetails.996022b6.js","h2Rtl","WorkflowDetails.66e2de36.js","35Qrf","CreateNewWorkflow.49f4082f.js","gSeeH","SubmissionsList.294e1c54.js","bHZfw","Gallery.0b685c9a.js","aeRor","CreateNewWorkflow.0319db04.js","4gaav","index.be1c989e.css"]'));

},{"32f4f186b1340ddd":"2yiuB","20f30af087700421":"ax3Cf"}],"2yiuB":[function(require,module,exports) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"ax3Cf":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return "/";
}
function getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}]},["26n5k"], null, "parcelRequiredc43")

//# sourceMappingURL=index.runtime.9dae6a37.js.map
